import { AnyChart } from '@d3fc/d3fc-chart';
import { LiquiditySummarySelection } from './selection';

export function renderYAxis(chart: AnyChart) {
    chart.yDecorate((selection: LiquiditySummarySelection) => {
        const node = selection.node();
        if (!node) {
            return;
        }

        selection.select('path').remove();
    });

    chart.yTickValues([0, 1]);
    chart.yTickFormat((d: number) => {
        switch (d) {
            case 0:
                return 'Today';
            case 1:
                return 'Historical';
            default:
                return '';
        }
    });
}
